<ng-template cdkPortal>
  <mat-spinner></mat-spinner>
</ng-template>

<router-outlet></router-outlet>
